import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMq from 'vue-mq'

import * as VueGoogleMaps from "vue2-google-maps";
import YmapPlugin from 'vue-yandex-maps'


Vue.use(VueMq, {
  breakpoints: {
//      mobile: infinity
    mobile: 4800,
    tablet: 9000,
    desktop: Infinity,
  }
})

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBOWbgDUZMDpg1pltHf92lEafHZpZ-rTfg",
    libraries: "places", // necessary for places input
    region: "ru,ru"
  }
})

Vue.use(YmapPlugin, {
  apiKey: 'e3a6e39d-6781-43a1-bc39-14e548e934ca',
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
